<div class="container mt-3" id="container">
  <div class="row mb-3 d-print-none">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <button type="button" class="btn btn-primary btn-lg" (click)="printPriceListLayout()">
                <i class="fa fa-print"></i><br />Print
              </button>
            </div>
            <div class="col text-right">
              <button type="button" class="btn btn-primary btn-lg" (click)="downloadPdfPriceListLayout()">
                <i class="fa fa-file-pdf"></i><br />PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div data-size="A4" id="paper-container" #container>
    <div id="main-container" style="width: 80mm; min-height: 200mm">
      <div class="text-center">
        {{today.toDate() | date:'d-MM-yyyy HH:mm:ss'}}
      </div>
      <h2 style="margin: 15px 0;">Produktliste</h2>
      <ng-container *ngFor="let category of priceList.productCategories">
        <h3 style="margin: 0px;">{{category.name}}</h3>
        <ul class="list-unstyled" style="margin: 0px;">
          <li *ngFor="let product of category.products">
            <div class="row">
              <div class="col-9">
                <span>1 x {{product.name}} {{product.extraInfo}}</span>
              </div>
              <div class="col-3 text-right" style="font-size: 10px">
                {{product.price | currency: eventCurrency + ' '}}
              </div>
            </div>
            <div class="row" *ngIf="product.productOptions.length > 0">
              <div class="col">
                <ul class="list-unstyled" style="margin: 0px;">
                  <li *ngFor="let option of product.productOptions">
                    <div class="row">
                      <div class="col-9">
                        <strong>
                          {{option.name}}
                        </strong>
                      </div>
                      <div class="col-3 text-right" style="font-size: 10px">
                        {{option.price | currency: eventCurrency + ' '}}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
      <div class="mt-3 text-center">
        <span>Danke!</span> <br />
        <span>Ausdruck by www.famulus.it</span>
      </div>
    </div>
  </div>
</div>
